
export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
  */

  'summary.getStarted': 'Contact Me',

  'contactFormSubmitted.success.title': 'Form submitted',
  'contactFormSubmitted.success.message': 'A Hancock Whitney Banker will contact you soon and an email will be sent to you with a link to your recommendations.',

  'summary.steps.title': 'Next Steps',
  'summary.steps.subtitle': 'Have a banker contact you with more information on these products and services, or get started by applying for select accounts online today',

  'summary.actions.email': 'Email me my recommendations',
  'summary.applyNow': 'Apply Now',

  /**
   * ============================
   * QUESTION MESSAGES
   * ============================
  */
};
